/**
 * Mixin zabezpieczający wychodzenie focusa z elementu np. modala.
 *
 * @export
 * @param {string} trigger
 * @param {boolean} [valueToTrigger=true]
 * @returns
 */
export function focusMixin(trigger = 'show', valueToTrigger = true) {
  return {
    data() {
      return {
        focusableElements: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        element: undefined,
        focusableContent: undefined,
        firstFocusableElement: undefined,
        lastFocusableElement: undefined
      };
    },
    methods: {
      // @vuese
      // Przygotowanie wszystkich potrzebnych elementów html'a
      prepareFocusMixin() {
        this.element = this.$el;
        if (!this.element) return;

        this.focusableContent = this.element.querySelectorAll(this.focusableElements);
        if (!this.focusableContent) return;

        this.firstFocusableElement = this.focusableContent[0];
        this.lastFocusableElement = this.focusableContent[this.focusableContent.length - 1];
      },
      // @vuese
      // Przenoszenie focusa na pierwszy lub ostatni element w drzewie html
      eventListenerFunction(event) {
        if (!event.key === 'Tab' || event.keyCode !== 9) return;

        if (event.shiftKey && document.activeElement === this.firstFocusableElement) {
          this.lastFocusableElement.focus();
          event.preventDefault();
        } else if (document.activeElement === this.lastFocusableElement) {
          this.firstFocusableElement.focus();
          event.preventDefault();
        }
      },
      // @vuese
      // Dodawanie eventListenera oraz ustawienie focusa domyślnie na pierwszym elemencie
      addEventListener() {
        this.prepareFocusMixin();
        document.addEventListener('keydown', this.eventListenerFunction);
        this.$nextTick(() => this.firstFocusableElement.focus());
      },
      // @vuese
      // Usuwanie eventListenera
      removeEventListener() {
        document.removeEventListener('keydown', this.eventListenerFunction);
      }
    },
    beforeDestroy() {
      this.removeEventListener();
    },
    watch: {
      [trigger](value) {
        if (value === valueToTrigger) {
          this.addEventListener();
        }
      }
    }
  };
}
